import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import GiftWrapperList from '../../../../../components/GiftWrapperList/GiftWrapperList';

function ConfirmationGiftWrapper({ orderGiftWrapInfo, orderInfo }) {
    if (isEmpty(orderGiftWrapInfo)) {
        return null;
    }
    return <GiftWrapperList giftWrapsInfo={orderGiftWrapInfo} currency={orderInfo.currency} />;
}

ConfirmationGiftWrapper.propTypes = {
    orderInfo: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number])
    ).isRequired,
    orderGiftWrapInfo: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = ({ orderInfo, orderGiftWrapInfo }) => ({
    orderInfo,
    orderGiftWrapInfo,
});

export default connect(mapStateToProps)(ConfirmationGiftWrapper);
